/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EAFSGAreaDTO,
    EAFSGAreaDTOFromJSON,
    EAFSGAreaDTOFromJSONTyped,
    EAFSGAreaDTOToJSON,
} from './EAFSGAreaDTO';

/**
 * 
 * @export
 * @interface EAFSGAreaDTOPagedResponse
 */
export interface EAFSGAreaDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof EAFSGAreaDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof EAFSGAreaDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof EAFSGAreaDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<EAFSGAreaDTO>}
     * @memberof EAFSGAreaDTOPagedResponse
     */
    data?: Array<EAFSGAreaDTO> | null;
}

export function EAFSGAreaDTOPagedResponseFromJSON(json: any): EAFSGAreaDTOPagedResponse {
    return EAFSGAreaDTOPagedResponseFromJSONTyped(json, false);
}

export function EAFSGAreaDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EAFSGAreaDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(EAFSGAreaDTOFromJSON)),
    };
}

export function EAFSGAreaDTOPagedResponseToJSON(value?: EAFSGAreaDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(EAFSGAreaDTOToJSON)),
    };
}

